import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./CadastroPerfil.css";
import CadastroHeader from "../../../components/CadastroHeader/CadastroHeader";
import { Box, Paper, Button } from "@mui/material";
import styles from "../../../styles/styles";
import { api } from "../../../services/apiService";
import Modal from "../../../components/Modal/Modal";

function CadastroPerfil() {

  const navigate = useNavigate();
  const location = useLocation();

  const perfilEdit =
    location.state && (location.state.id || location.state.Id)
      ? location.state
      : null;

  const [nomePerfil, setNomePerfil] = useState(perfilEdit?.nome ?? "");
  const [descricao, setDescricao] = useState(perfilEdit?.descricao ?? "");

  const [permissions, setPermissions] = useState({
    usuario: { criar: false, editar: false, deletar: false },
    perfil: { criar: false, editar: false, deletar: false },
    trem: { criar: false, editar: false, deletar: false }
  });

  const [modal, setModal] = useState({
    show: false,
    type: "error",
    message: ""
  });

  useEffect(() => {

    if (perfilEdit && perfilEdit.acoesPerfil && perfilEdit.acoesPerfil.length > 0) {

      const updatedPermissions = {
        usuario: { criar: false, editar: false, deletar: false },
        perfil: { criar: false, editar: false, deletar: false },
        trem: { criar: false, editar: false, deletar: false }
      };

      perfilEdit.acoesPerfil.forEach((item) => {

        if (item.acoes && Array.isArray(item.acoes)) {

          item.acoes.forEach((acaoItem) => {

            const Recurso = acaoItem.Recurso || acaoItem.recurso;
            const Acao = acaoItem.Acao || acaoItem.acao;

            if (Recurso && Acao) {

              const recursoNormalizado = Recurso.toLowerCase();
              const acaoNormalizada = Acao.toLowerCase();

              if (
                updatedPermissions[recursoNormalizado] &&
                updatedPermissions[recursoNormalizado][acaoNormalizada] !== undefined
              ) {
                updatedPermissions[recursoNormalizado][acaoNormalizada] = true;
              }

            }

          });

        }

      });

      setPermissions(updatedPermissions);

    }

  }, [perfilEdit]);

  const handlePermissionChange = (entity, action) => {

    setPermissions({
      ...permissions,
      [entity]: {
        ...permissions[entity],
        [action]: !permissions[entity][action]
      }
    });

  };

  const handleSave = async () => {

    if (nomePerfil.trim() === "") {

      setModal({
        show: true,
        type: "error",
        message: "Preencha o nome do perfil antes de salvar!"
      });

      return;

    }

    const permissoesArray = [];

    Object.entries(permissions).forEach(([recurso, acoes]) => {

      Object.entries(acoes).forEach(([acao, permitido]) => {

        if (permitido) {

          permissoesArray.push({
            Acao: acao.charAt(0).toUpperCase() + acao.slice(1),
            Recurso: recurso.charAt(0).toUpperCase() + recurso.slice(1)
          });

        }

      });

    });

    const perfilPayload = {
      nome: nomePerfil,
      descricao,
      AcoesPerfil: [
        {
          Acoes: permissoesArray
        }
      ]
    };

    try {

      const isEdit = perfilEdit && (perfilEdit.id || perfilEdit.Id);

      isEdit
        ? await api.perfil.update(perfilEdit.id || perfilEdit.Id, perfilPayload)
        : await api.perfil.create(perfilPayload);

      setModal({
        show: true,
        type: "success",
        message: isEdit
          ? "Perfil atualizado com sucesso!"
          : "Perfil cadastrado com sucesso!"
      });

      setTimeout(() => {

        setModal({ ...modal, show: false });

        navigate("/cadastroPage");

      }, 2000);

    } catch (error) {

      setModal({
        show: true,
        type: "error",
        message: "Erro ao salvar perfil."
      });

    }

  };

  return (

    <Box sx={styles.pageWrapper}>


      <Box component="main" sx={styles.mainContent}>

        <Paper elevation={0} sx={styles.card}>

          <CadastroHeader
            title={perfilEdit ? "Editar Perfil" : "Cadastro de Perfil"}
            subtitle={
              perfilEdit
                ? "Edite os dados e permissões deste perfil."
                : "Adicione um novo perfil e defina as ações permitidas."
            }
          />

          <Modal
            show={modal.show}
            type={modal.type}
            message={modal.message}
            onClose={() => setModal({ ...modal, show: false })}
          />

          <div className="form-card">

            <label>Nome do Perfil</label>

            <input
              type="text"
              value={nomePerfil}
              onChange={(e) => setNomePerfil(e.target.value)}
              placeholder="Digite o nome do perfil"
            />

            <label>Descrição</label>

            <textarea
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Digite a descrição"
            />

            <label>Ações permitidas</label>

            <div className="permissions-list">

              {Object.keys(permissions).map((entity) => (

                <div key={entity} className="permission-group">

                  <h4>
                    {entity.charAt(0).toUpperCase() + entity.slice(1)}
                  </h4>

                  {Object.keys(permissions[entity]).map((action) => (

                    <label key={action} className="checkbox-item">

                      <input
                        type="checkbox"
                        checked={permissions[entity][action]}
                        onChange={() => handlePermissionChange(entity, action)}
                      />

                      {action.charAt(0).toUpperCase() + action.slice(1)}

                    </label>

                  ))}

                </div>

              ))}

            </div>

            <p
              style={{
                color: "#6b7280",
                fontSize: "14px",
                marginTop: "10px",
                marginBottom: "20px"
              }}
            >
              * Se nenhuma ação for selecionada em uma seção,
              ela não ficará visível para o usuário.
            </p>

            <Button
              variant="contained"
              onClick={handleSave}
            >
              {perfilEdit ? "Atualizar" : "Cadastrar"}
            </Button>

          </div>

        </Paper>

      </Box>

    </Box>

  );

}

export default CadastroPerfil;
